import Vue from 'vue'
import './styles/quasar.styl'
import 'quasar/dist/quasar.ie.polyfills'
import lang from 'quasar/lang/he.js'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
import {
  Quasar,
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QInnerLoading,
  QSpinner,
  QInput,
  QDate,
  QPopupProxy,
  QDialog,
  QFooter,
  ClosePopup,
  QSpace,
  Ripple,
  QSeparator,
  QExpansionItem,
  QCard,
  QCardSection,
  QCardActions,
  QForm,
  QSplitter,
  QTree,
  QTabPanels,
  QTabPanel,
  QCheckbox,
  QLinearProgress,
  QSelect,
  QUploader,
  QRadio,
  QOptionGroup,
  QField,
  QBtnGroup,
  QTooltip,
  QTab,
  QTabs,
  QRouteTab,
  QBtnDropdown,
  QPopupEdit,
  QPageSticky,
  Notify,
  Dialog
} from 'quasar'

Vue.use(Quasar, {
  config: {},
  components: {
    QLayout,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QInnerLoading,
    QSpinner,
    QInput,
    QDate,
    QPopupProxy,
    QDialog,
    QFooter,
    QSpace,
    QSeparator,
    QExpansionItem,
    QCard,
    QCardSection,
    QCardActions,
    QForm,
    QSplitter,
    QTree,
    QTabPanels,
    QTabPanel,
    QCheckbox,
    QLinearProgress,
    QSelect,
    QUploader,
    QRadio,
    QOptionGroup,
    QField,
    QBtnGroup,
    QTooltip,
    QTab,
    QTabs,
    QBtnDropdown,
    QRouteTab,
    QPopupEdit,
    QPageSticky
  },
  directives: {
    ClosePopup,
    Ripple
  },
  plugins: {
    Notify,
    Dialog
  },
  lang: lang
})